import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["product", "display", "input"];

  connect() {
    this.update();
  }

  update() {
    const option = this.productTarget.selectedOptions[0];
    const price = option?.dataset.price || "";
    this.displayTarget.textContent = price
      ? `¥${Number(price) / 100}`
      : "请选择商品";
    this.inputTarget.value = price ? Number(price) / 100 : "";
  }
}
